(() => {
  const HC = (window.HC = window.HC || {});

  HC.setCartCount = (n) => {
    document.querySelectorAll('[data-hc-cart-count]').forEach((el) => (el.textContent = n));
  };

  // Close an overlay with its exit animation, then hide it (design: 300–320ms).
  HC.closeAnimated = (el, ms) => {
    if (!el || el.hidden || el.classList.contains('is-closing')) return;
    el.classList.add('is-closing');
    setTimeout(() => {
      el.hidden = true;
      el.classList.remove('is-closing');
    }, ms);
  };

  /* ---------- Bag drawer ---------- */
  const bag = () => document.querySelector('[data-hc-bag]');

  HC.openBag = () => {
    const el = bag();
    if (!el) { window.location.href = window.routes?.cart_url || '/cart'; return; }
    el.classList.remove('is-closing');
    el.hidden = false;
  };
  HC.closeBag = () => HC.closeAnimated(bag(), 320);

  // Swap in freshly rendered drawer markup from the Section Rendering API.
  HC.renderBag = (html) => {
    const el = bag();
    if (!el || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-hc-bag-content]');
    const current = el.querySelector('[data-hc-bag-content]');
    if (fresh && current) current.replaceWith(fresh);
    const count = doc.querySelector('[data-hc-bag]')?.dataset.count;
    if (count != null) {
      el.dataset.count = count;
      HC.setCartCount(count);
    }
    HC.updateHold();
  };

  /* ---------- Reservation timer (design: holdUntil / holdLabel / holdClock) ---------- */
  const HOLD_KEY = 'hc-hold-until';
  const HOLD_MS = 10 * 60 * 1000;
  const readHold = () => {
    try { return Number(localStorage.getItem(HOLD_KEY)) || 0; } catch (e) { return 0; }
  };
  const writeHold = (t) => {
    try { localStorage.setItem(HOLD_KEY, String(t)); } catch (e) {}
  };

  // As in the design's add(): keep a running hold, otherwise start a new 10:00.
  HC.startHold = () => {
    if (!(readHold() > Date.now())) writeHold(Date.now() + HOLD_MS);
  };

  HC.updateHold = () => {
    const el = bag();
    const hold = el && el.querySelector('[data-hc-hold]');
    if (!hold) return;
    const until = readHold();
    if (!Number(el.dataset.count) || !until) { hold.hidden = true; return; }
    const left = Math.max(0, until - Date.now());
    const m = Math.floor(left / 60000);
    const s = Math.floor((left % 60000) / 1000);
    hold.querySelector('[data-hc-hold-label]').textContent = left > 0
      ? 'Items in your cart are reserved for:'
      : 'Your reservation has ended. Items stay in your bag, subject to stock.';
    hold.querySelector('[data-hc-hold-clock]').textContent = left > 0
      ? String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
      : '';
    hold.hidden = false;
  };

  setInterval(HC.updateHold, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', HC.updateHold);
  else HC.updateHold();

  const cartRequest = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: 'hc-bag-drawer', sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
    return data;
  };

  HC.addToBag = async (id, quantity) => {
    try {
      const data = await cartRequest((window.routes?.cart_add_url || '/cart/add') + '.js', { items: [{ id: Number(id), quantity }] });
      HC.startHold();
      HC.renderBag(data.sections?.['hc-bag-drawer']);
      HC.openBag();
    } catch (err) {
      window.alert(err.message);
    }
  };

  HC.removeFromBag = async (key) => {
    try {
      const data = await cartRequest((window.routes?.cart_change_url || '/cart/change') + '.js', { id: key, quantity: 0 });
      HC.renderBag(data.sections?.['hc-bag-drawer']);
    } catch (err) {
      window.alert(err.message);
    }
  };

  /* ---------- Clicks ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-hc-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
      if (nav) nav.hidden = !open;
      return;
    }

    if (e.target.closest('[data-hc-bag-open]')) {
      e.preventDefault();
      HC.closeMenu();
      HC.openBag();
      return;
    }

    if (e.target.closest('[data-hc-bag-close]')) {
      HC.closeBag();
      return;
    }

    const remove = e.target.closest('[data-hc-bag-remove]');
    if (remove) {
      remove.disabled = true;
      HC.removeFromBag(remove.dataset.hcBagRemove);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') HC.closeBag();
  });

  HC.closeMenu = () => {
    document.querySelectorAll('[data-hc-menu-toggle][aria-expanded="true"]').forEach((t) => {
      t.setAttribute('aria-expanded', 'false');
      t.textContent = 'Menu';
      const nav = document.getElementById(t.getAttribute('aria-controls'));
      if (nav) nav.hidden = true;
    });
  };

  // Keep the drawer and header count in sync when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', async (e) => {
    if (!e.persisted) return;
    const res = await fetch('?sections=hc-bag-drawer');
    if (res.ok) HC.renderBag((await res.json())['hc-bag-drawer']);
  });
})();
